import { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { Text, tokens } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';

const HIDE_AFTER = 5000;

const Box = styled(Text)<{ leftOffset: number }>`
  position: fixed;
  background-color: ${tokens.color.white};
  padding: ${tokens.spacer.x1pt5} ${tokens.spacer.x2};
  border-radius: ${tokens.spacer.x0pt5};
  width: 460px;
  bottom: ${tokens.spacer.x5};
  left: ${({ leftOffset }) => `calc(50% + ${leftOffset}px)`};
  transform: translateX(-50%);
`;

interface CreateHighlightInfoBarProps {
  leftOffset: number;
}

export const CreateHighlightInfoBar = ({
  leftOffset,
}: CreateHighlightInfoBarProps): JSX.Element | null => {
  const [isVisible, setIsVisible] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    const hideTimeout = setTimeout(() => {
      setIsVisible(false);
    }, HIDE_AFTER);

    return () => {
      clearTimeout(hideTimeout);
    };
  }, [setIsVisible]);

  if (isVisible) {
    return (
      <Box as="p" leftOffset={leftOffset} textType="caption">
        {t('highlights:heatmaps.helpBar')}
      </Box>
    );
  }

  return null;
};
